import React from 'react';
import { Box } from '@mui/material';
import useMedicationAdministrationReview from './hooks/useMedicationAdministrationReview';
import MedicationAdministrationReviewActions from './MedicationAdministrationReviewActions';
import MedicationAdministrationReviewSheet from './MedicationAdministrationReviewSheet';

const StoryMedicationReviewScene = ({
  scene = {},
  childName = '',
  children,
  onStatusChange = null,
}) => {
  const controller = useMedicationAdministrationReview({
    entryId: scene.id || '',
    entryData: scene,
  });

  React.useEffect(() => {
    onStatusChange?.(scene.id || '', controller.status);
  }, [controller.status, onStatusChange, scene.id]);

  if (!controller.status) {
    return children;
  }

  return (
    <Box data-medication-review-status={controller.status}>
      {children}
      <MedicationAdministrationReviewActions controller={controller} />
      <MedicationAdministrationReviewSheet
        controller={controller}
        childName={childName || scene.childName || ''}
      />
    </Box>
  );
};

export default StoryMedicationReviewScene;
